import * as Yup from 'yup';
import { getProductShape } from 'validators/Common/baseTransitTimeValidator';

export class UpdateTransitTimeValidator {
  public get schema() {
    return Yup.object().shape({
      ...getProductShape()
    });
  }
}
